import { useState } from 'preact/hooks'

// Club-form words that make poor initials ("CD Yuncos" → "YU", not "CY").
const CLUB_FORM = /^(cd|cf|fc|ud|sd|ad|ae|ce|ue|cp|sad|club|rcd|rc|ca|scd|sc|ac|afc)$/i

/** Up to two initials: first letters of the first two words, or the first
 *  two letters of a one-word name ("Atletico Calatayud" → "AC", "Lebrijana" → "LE"). */
export function initials(name: string): string {
  const words = name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .split(/[^A-Za-z0-9]+/)
    .filter(Boolean)
  const core = words.filter((w) => !CLUB_FORM.test(w))
  const use = core.length ? core : words
  if (use.length === 0) return ''
  const out = use.length >= 2 ? use[0][0] + use[1][0] : use[0].slice(0, 2)
  return out.toUpperCase()
}

/**
 * A team crest that never leaves a hole: with no URL, or when the image fails
 * to load (the API answers 404 when no source has the crest), it renders a
 * neutral circle with the team's initials in the same 18px box, so the row
 * doesn't shift.
 */
export function TeamCrest({ src, name }: { src?: string | null; name: string }) {
  // The URL that failed, not a flag: a refreshed feed with a new URL retries.
  const [failed, setFailed] = useState<string | null>(null)
  if (src && failed !== src) {
    return <img class="crest" src={src} alt="" width={18} height={18} onError={() => setFailed(src)} />
  }
  return (
    <span class="crest crest-ph" aria-hidden="true">
      {initials(name)}
    </span>
  )
}

export const teamCrestStyles = `
  .crest-ph {
    display: inline-flex; align-items: center; justify-content: center;
    width: 18px; height: 18px; flex: none; border-radius: 50%;
    background: var(--sports-border); color: var(--sports-muted);
    font-size: 7.5px; font-weight: 700; line-height: 1; letter-spacing: 0.02em;
    overflow: hidden; user-select: none;
  }
`
